module.exports = __webpack_public_path__ + "img/marker_dormir.b7837735.svg";